//import Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';

// import Components

import MyPageTextFormLine from './MyPageTextFormLine';
import MyPageButton from './MyPageButton';
import MyPageEditConfirmButton from './MyPageEditConfirmButton';

import Language from '../../language/language.json'

import * as mypageActions from './actions/mypageActions'
import * as modalActions from '../../components/Navigation/actions/modalActions';
import * as validations from '../../utils/validations'

//import Styles
import './MyInfo.css'
import MyPage from './MyPage';

class MyInfo extends Component {

    constructor(props){
        super(props);

        const {user} = props;

        this.state = { 
            editing : false,

            phone : user.phone,
            phoneError : '',

            address : user.address,
            addressError : '',

            greenhouseType : user.greenhouseType,
            greenhouseTypeError : '',

            plantType : user.plantType,
            plantTypeError : '',

            areaSize : user.areaSize,
            areaSizeError : '',

            newPassword : '',
            newPasswordError : '',
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    checkPassword = (s) => {
        if(s === '') {
            return ''
        }
        const {language} = this.props.universal;

        let passwordError = '';
        if(!validations.validatePasswordSpecialCharacters(s)) {
            passwordError = Language.signUp.validation.password.specialCharacters[language];
        }
        if(!validations.validatePasswordNumber(s)) {
            passwordError = Language.signUp.validation.password.hasNumber[language];
        }
        if(!validations.validatePasswordAlphabet(s)) {
            passwordError = Language.signUp.validation.password.hasAlphabet[language];
        }
        if(!validations.validatePasswordLength(s)) {
            passwordError = Language.signUp.validation.password.short[language];
        }
        return passwordError;
    }

    handleNewPasswordChange = (e) => {
        this.setState({
            newPassword : e.target.value,
            newPasswordError : this.checkPassword(e.target.value),
            updatePasswordError : '',
        })
    } 

    canCommitNewInfo = () => {

        let isNewData = true;

        isNewData &= this.state.phone !== '';
        isNewData &= this.state.address !== '';
        isNewData &= this.state.greenhouseType !== '';
        isNewData &= this.state.plantType !== '';
        isNewData &= this.state.areaSize !== '';

        let isNewPassword = false;
        isNewPassword = this.state.newPassword !== '';

        console.log(isNewData);

        return isNewData || isNewPassword;
    }

    render() {
        const {user} = this.props;
        const {language} = this.props.universal;

        return (
            <div className="MyInfo">
                <h2>{language=="ko"?"회원정보":"User Information"}</h2>
                <hr/>
                <MyPageTextFormLine
                    editing={false}
                    label={Language.mypage.name[language]}
                    value={`${user.fullName}`}
                />
                <MyPageTextFormLine
                    editing={false}
                    label={Language.mypage.email[language]}
                    value={user.email}
                />
                <MyPageTextFormLine
                    editing={this.state.editing}
                    label={Language.mypage.address[language]}
                    name="address"
                    value={this.state.editing ? this.state.address : user.address}
                    handleOnChange={this.handleOnChange}
                    errorText={this.state.addressError}
                />
                <MyPageTextFormLine
                    editing={this.state.editing}
                    label={Language.mypage.phone[language]}
                    name="phone"
                    value={this.state.editing ? this.state.phone : user.phone}
                    handleOnChange={this.handleOnChange}
                    placeholder={'000-0000-0000'}
                    errorText={this.state.phoneError}
                />

                <MyPageTextFormLine
                    editing={this.state.editing}
                    label={Language.mypage.greenhouseType[language]}
                    name="greenhouseType"
                    value={this.state.editing ? this.state.greenhouseType : user.greenhouseType}
                    handleOnChange={this.handleOnChange}
                    errorText={this.state.greenhouseTypeError}
                />
                <MyPageTextFormLine
                    editing={this.state.editing}
                    label={Language.mypage.plantType[language]}
                    name="plantType"
                    value={this.state.editing ? this.state.plantType : user.plantType}
                    handleOnChange={this.handleOnChange}
                    errorText={this.state.plantTypeError}
                />
                <MyPageTextFormLine
                    editing={this.state.editing}
                    label={Language.mypage.areaSize[language]}
                    name="areaSize"
                    value={this.state.editing ? this.state.areaSize : user.areaSize}
                    handleOnChange={this.handleOnChange}
                    errorText={this.state.areaSizeError}
                />

                <MyPageTextFormLine
                    type="password"
                    editing={this.state.editing}
                    label={Language.mypage.newPassword[language]}
                    name="newPassword"
                    value={this.state.newPassword}
                    handleOnChange={this.handleNewPasswordChange}
                    errorText={this.state.newPasswordError}
                />
                <div className="Buttons">
                    <MyPageEditConfirmButton 
                        editing={this.state.editing}
                        editLabel={Language.mypage.editInfo[language]}
                        confirmLabel={Language.mypage.confirm[language]}
                        cancleLabel={Language.mypage.cancle[language]}
                        onToggle={() => {
                            this.setState(prevState => ({
                                editing : !prevState.editing
                            }))
                        }}
                        onConfirm={() => {
                            if(this.canCommitNewInfo()) {
                                this.props.onSaveNewInfo({
                                    phone : this.state.phone === '' ? null : this.state.phone,
                                    address : this.state.address  === '' ? null : this.state.address,
                                    greenhouseType : this.state.greenhouseType === '' ? null : this.state.greenhouseType,
                                    plantType : this.state.plantType === '' ? null : this.state.plantType,
                                    areaSize : this.state.areaSize === '' ? null : this.state.areaSize,
                                    newPassword : this.state.newPassword === '' ? null : this.state.newPassword,
                                });
                                this.props.onToggleModal('updateUserInfo');
                                this.setState({
                                    newPassword : ''
                                });
                            }
                        }}
                        onCancle={() => {
                            this.setState({
                                address: user.address,
                                phone: user.phone
                            })
                        }}
                        confirmDisabled={this.state.newPasswordError === '' ? false : true}
                    />
                    <MyPageButton
                        value={Language.mypage.signOut[language]}
                        onClick={() => this.props.onSignOut()}
                    />
                    {
                        !user.verified && (
                            <MyPageButton
                                value={Language.mypage.sendVerification[language]}
                                onClick={() => this.props.onSendVerificationEmail({
                                    successFunc : () => {
                                        this.props.onToggleModal('verificationEmailSent')
                                    },
                                    failedFunc : () => {
                                        this.props.onToggleModal('verficationEmailSentFail')
                                    }
                                })}
                            />
                        )
                    }
                    <MyPageButton
                        value={Language.mypage.withdraw[language]}
                        onClick={ () => {
                            this.props.onToggleModal('withdraw');
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSignOut : () => {
            dispatch(mypageActions.signOut());
        },
        onSendVerificationEmail : (funcs) => {
            dispatch(mypageActions.sendVerificationEmail(funcs));
        },
        onToggleModal : (name) => {
            dispatch(modalActions.toggleModal(name));
        },
        onSaveNewInfo: (info) => {
            dispatch(mypageActions.saveNewInfo(info))
        }
    }
}

export default connect(null, mapDispatchToProps)(MyInfo);


// WEBPACK FOOTER //
// ./src/pages/MyPage/MyInfo.js